// Vendored from https://github.com/JoshVarga/html5-embroidery (MIT, see LICENSE in this folder) -
// only the closing invocation line at the bottom was changed (module.exports thay vì gán global window)
// để dùng được trong bundler (webpack/CRA), toàn bộ logic parse giữ nguyên 100%.
(function (global) {
  "use strict";
  function Stitch(x, y, flags, color) {
    this.flags = flags;
    this.x = x;
    this.y = y;
    this.color = color;
  }

  function Color(r, g, b, description) {
    this.r = r;
    this.g = g;
    this.b = b;
    this.description = description;
  }

  var stitchTypes = {
    normal: 0,
    jump: 1,
    trim: 2,
    stop: 4,
    end: 8,
  };

  function distanceSquared(a, b) {
    return Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2);
  }

  function lineIntersection(p1, p2, p3, p4) {
    var result = { x: null, y: null, intersects: false };
    var denominator = (p4.y - p3.y) * (p2.x - p1.x) - (p4.x - p3.x) * (p2.y - p1.y);
    if (denominator === 0) {
      return result;
    }
    var dy1 = p1.y - p3.y,
      dx1 = p1.x - p3.x,
      a = ((p4.x - p3.x) * dy1 - (p4.y - p3.y) * dx1) / denominator,
      b = ((p2.x - p1.x) * dy1 - (p2.y - p1.y) * dx1) / denominator;
    result.x = p1.x + a * (p2.x - p1.x);
    result.y = p1.y + a * (p2.y - p1.y);
    result.intersects = a > 0 && a < 1 && b > 0 && b < 1;
    return result;
  }

  function sortByDistanceDesc(a, b) {
    if (a.distance < b.distance) return 1;
    if (a.distance > b.distance) return -1;
    return 0;
  }

  function Pattern() {
    this.colors = [];
    this.stitches = [];
    this.hoop = {};
    this.lastX = 0;
    this.lastY = 0;
    this.top = 0;
    this.bottom = 0;
    this.left = 0;
    this.right = 0;
    this.currentColorIndex = 0;
  }

  Pattern.prototype.addColorRgb = function (r, g, b, description) {
    this.colors[this.colors.length] = new Color(r, g, b, description);
  };

  Pattern.prototype.addColor = function (color) {
    this.colors[this.colors.length] = color;
  };

  Pattern.prototype.addStitchAbs = function (x, y, flags, isAutoColorIndex) {
    if ((flags & stitchTypes.end) === stitchTypes.end) {
      this.calculateBoundingBox();
      this.fixColorCount();
    }
    if (
      (flags & stitchTypes.stop) === stitchTypes.stop &&
      this.stitches.length === 0
    ) {
      return;
    }
    if ((flags & stitchTypes.stop) === stitchTypes.stop && isAutoColorIndex) {
      this.currentColorIndex += 1;
    }
    this.stitches[this.stitches.length] = new Stitch(
      x,
      y,
      flags,
      this.currentColorIndex,
    );
  };

  Pattern.prototype.addStitchRel = function (dx, dy, flags, isAutoColorIndex) {
    if (this.stitches.length !== 0) {
      var nx = this.lastX + dx,
        ny = this.lastY + dy;
      this.lastX = nx;
      this.lastY = ny;
      this.addStitchAbs(nx, ny, flags, isAutoColorIndex);
    } else {
      this.addStitchAbs(dx, dy, flags, isAutoColorIndex);
    }
  };

  Pattern.prototype.calculateBoundingBox = function () {
    var i = 0,
      stitchCount = this.stitches.length,
      pt;
    if (stitchCount === 0) {
      this.bottom = 1;
      this.right = 1;
      return;
    }
    this.left = 99999;
    this.top = 99999;
    this.right = -99999;
    this.bottom = -99999;

    for (i = 0; i < stitchCount; i += 1) {
      pt = this.stitches[i];
      if (!(pt.flags & stitchTypes.trim)) {
        this.left = this.left < pt.x ? this.left : pt.x;
        this.top = this.top < pt.y ? this.top : pt.y;
        this.right = this.right > pt.x ? this.right : pt.x;
        this.bottom = this.bottom > pt.y ? this.bottom : pt.y;
      }
    }
  };

  Pattern.prototype.moveToPositive = function () {
    var i = 0,
      stitchCount = this.stitches.length;
    for (i = 0; i < stitchCount; i += 1) {
      this.stitches[i].x -= this.left;
      this.stitches[i].y -= this.top;
    }
    this.right -= this.left;
    this.left = 0;
    this.bottom -= this.top;
    this.top = 0;
  };

  Pattern.prototype.invertPatternVertical = function () {
    var i = 0,
      temp = -this.top,
      stitchCount = this.stitches.length;
    for (i = 0; i < stitchCount; i += 1) {
      this.stitches[i].y = -this.stitches[i].y;
    }
    this.top = -this.bottom;
    this.bottom = temp;
  };

  Pattern.prototype.moveToCenter = function () {
    var i = 0,
      stitchCount = this.stitches.length,
      centerX = (this.right + this.left) / 2,
      centerY = (this.bottom + this.top) / 2;
    for (i = 0; i < stitchCount; i += 1) {
      this.stitches[i].x -= centerX;
      this.stitches[i].y -= centerY;
    }
    this.right -= centerX;
    this.left -= centerX;
    this.bottom -= centerY;
    this.top -= centerY;
  };

  Pattern.prototype.addColorRandom = function () {
    this.colors[this.colors.length] = new Color(
      Math.round(Math.random() * 256),
      Math.round(Math.random() * 256),
      Math.round(Math.random() * 256),
      "random",
    );
  };

  Pattern.prototype.fixColorCount = function () {
    var maxColorIndex = 0,
      stitchCount = this.stitches.length,
      i;
    for (i = 0; i < stitchCount; i += 1) {
      maxColorIndex = Math.max(maxColorIndex, this.stitches[i].color);
    }
    while (this.colors.length <= maxColorIndex) {
      this.addColorRandom();
    }
    this.colors.splice(
      maxColorIndex + 1,
      this.colors.length - maxColorIndex - 1,
    );
  };

  Pattern.prototype.drawShape = function (canvas) {
    canvas.width = this.right;
    canvas.height = this.bottom;
    if (canvas.getContext) {
      var ctx = canvas.getContext("2d");
      ctx.beginPath();
      var color = this.colors[this.stitches[0].color];
      ctx.strokeStyle = "rgb(" + color.r + "," + color.g + "," + color.b + ")";
      for (var i = 0; i < this.stitches.length; i++) {
        var currentStitch = this.stitches[i];
        if (
          currentStitch.flags === stitchTypes.jump ||
          currentStitch.flags === stitchTypes.trim ||
          currentStitch.flags === stitchTypes.stop
        ) {
          ctx.stroke();
          var color = this.colors[currentStitch.color];
          ctx.beginPath();
          ctx.strokeStyle =
            "rgb(" + color.r + "," + color.g + "," + color.b + ")";
          ctx.moveTo(currentStitch.x, currentStitch.y);
        }
        ctx.lineTo(currentStitch.x, currentStitch.y);
      }
      ctx.stroke();
    } else {
      global.alert("You need Safari or Firefox 1.5+ to see this demo.");
    }
  };

  // Gives every stitch a z-height and nudges it up wherever an earlier thread
  // is crossed, so overlapping stitches stack instead of intersecting in 3D.
  Pattern.prototype.removeUnderlayment = function (zStep) {
    var i, j, prev, current, crossing, crossStitch, segmentLength, ratio, lastZ;
    this.stitches[0].z = zStep;
    for (i = 1; i < this.stitches.length; i += 1) {
      prev = this.stitches[i - 1];
      current = this.stitches[i];
      current.z = zStep;
      for (j = 1; j < i - 1; j += 1) {
        crossing = lineIntersection(
          prev,
          current,
          this.stitches[j - 1],
          this.stitches[j],
        );
        if (crossing.intersects) {
          current.crossed = current.crossed || [];
          crossStitch = new Stitch(
            crossing.x,
            crossing.y,
            current.flags,
            current.color,
          );
          segmentLength = distanceSquared(this.stitches[j], this.stitches[j - 1]);
          if (segmentLength !== 0) {
            ratio = distanceSquared(this.stitches[j - 1], crossing) / segmentLength;
            crossStitch.z =
              ratio * (this.stitches[j].z - this.stitches[j - 1].z) +
              2 * zStep +
              this.stitches[j - 1].z;
            crossStitch.distance = distanceSquared(crossStitch, current);
            current.crossed.push(crossStitch);
          }
        }
      }
      if (current.crossed) {
        current.crossed.sort(sortByDistanceDesc);
        lastZ = current.z;
        for (j = 0; j < current.crossed.length; j += 1) {
          if (lastZ < current.crossed[j].z) {
            this.stitches.splice(i, 0, current.crossed[j]);
            lastZ = current.crossed[j].z;
            i += 1;
          }
        }
        current.crossed = null;
      }
    }
    for (i = 1; i < this.stitches.length; i += 1) {
      prev = this.stitches[i - 1];
      current = this.stitches[i];
      if (Math.abs(prev.x - current.x) > 128 || Math.abs(prev.y - current.y) > 128) {
        this.stitches[i].flags = stitchTypes.trim;
      }
    }
  };

  // Groups the stitches into one continuous thread run per color and gives
  // each point a z so display3d.js can extrude a tube along it.
  // Cached because it mutates this.stitches (invert/center/splice) and must
  // not be re-applied if the 3D view is toggled on more than once.
  Pattern.prototype.drawShape3d = function () {
    if (this._shape3d) {
      return this._shape3d;
    }
    if (this.stitches.length === 0) {
      return null;
    }
    this.invertPatternVertical();
    this.moveToCenter();
    this.removeUnderlayment(1);

    var groups = [{ color: this.colors[this.stitches[0].color], points: [] }];
    var currentGroup = groups[0];
    for (var i = 0; i < this.stitches.length - 1; i += 1) {
      var stitch = this.stitches[i];
      if (
        stitch.flags === stitchTypes.jump ||
        stitch.flags === stitchTypes.trim ||
        stitch.flags === stitchTypes.stop
      ) {
        currentGroup = { color: this.colors[stitch.color], points: [] };
        groups.push(currentGroup);
        currentGroup.points.push({ x: stitch.x, y: stitch.y, z: 0 });
      }
      currentGroup.points.push({ x: stitch.x, y: stitch.y, z: stitch.z });
    }
    this._shape3d = groups;
    return groups;
  };

  global.Color = Color.prototype.constructor;
  global.Pattern = Pattern.prototype.constructor;
  global.stitchTypes = stitchTypes;
})(typeof module !== "undefined" && module.exports ? module.exports : this);
